import Profile from '@/components/Profile'
import PrimaryPageLayout from '@/layouts/PrimaryPageLayout'
import { HugeiconsIcon } from '@hugeicons/react'
import { UserCircleIcon } from '@hugeicons/core-free-icons'
import { forwardRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useCurrentPubkey } from '@/atoms/session'

const ProfilePage = forwardRef(({ id }: { id?: string }, ref) => {
  const pubkey = useCurrentPubkey()
  const profileId = id ?? pubkey

  if (!profileId) return null

  return (
    <PrimaryPageLayout
      pageName="profile"
      titlebar={<ProfilePageTitlebar />}
      displayScrollToTopButton
      ref={ref}
    >
      <Profile id={profileId} />
    </PrimaryPageLayout>
  )
})
ProfilePage.displayName = 'ProfilePage'
export default ProfilePage

function ProfilePageTitlebar() {
  const { t } = useTranslation()

  return (
    <div className="flex gap-2 items-center h-full pl-3">
      <HugeiconsIcon icon={UserCircleIcon} />
      <div className="text-lg font-semibold">{t('Profile')}</div>
    </div>
  )
}
